/* intc-sticky-product-media.js
   Adds Dawn's existing .product__column-sticky class to the product media
   column so it stays in view while the (taller) info column scrolls.
   That class is already desktop-only (min-width: 750px) via
   assets/section-main-product.css, so no extra breakpoint handling needed here.
*/
(function () {
  function initStickyMedia() {
    var media = document.querySelector('.product__media-wrapper');
    if (!media) return;
    media.classList.add('product__column-sticky');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyMedia);
  } else {
    initStickyMedia();
  }
})();
